import { Role } from '@/Enums/Users/Role.enum';
import ShieldCheckIcon from '@/components/Icons/ShieldCheckIcon';
import TvIcon from '@/components/Icons/TvIcon';
import UserIcon from '@/components/Icons/UserIcon';
import { CustomIcon } from '@/types/Icons/Icon.type';
import { useMemo } from 'react';

const ROLE_ICONS: Record<Role, CustomIcon> = {
  [Role.ADMIN]: ShieldCheckIcon,
  [Role.ORG_ADMIN]: ShieldCheckIcon,
  [Role.WHITELABEL_ADMIN]: ShieldCheckIcon,
  [Role.CLIENT]: TvIcon,
  [Role.ADVERTISER]: UserIcon,
  [Role.AGENCY]: UserIcon,
};

interface IProps {
  userRole?: Role;
  className?: string;
}

const UserTypeIcon = ({ userRole, className }: IProps) => {
  const Icon = useMemo(() => (userRole ? ROLE_ICONS[userRole] : null), [userRole]);

  return Icon ? <Icon className={className} /> : null;
};

export default UserTypeIcon;
